import React, { useEffect, useState } from "react";

const SHOP_DOMAIN = "cfhjyy-p6.myshopify.com";
const API_URL = `https://${SHOP_DOMAIN}/api/2024-07/graphql.json`;
const STOREFRONT_TOKEN = "5ddd3d844caa66d6983a6cfe924cfd8b"; // chỉ dùng cho frontend

const ShopifyProductList = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: `
          {
            products(first: 5) {
              edges {
                node {
                  id
                  title
                  description
                  images(first: 1) {
                    edges {
                      node {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const items = data.data.products.edges.map((edge) => edge.node);
        setProducts(items);
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  return (
    <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
      <h1>Shopify Product List</h1>
      <ul>
        {products.map((product) => (
          <li key={product.id} style={{ marginBottom: "1.5rem" }}>
            <h2>{product.title}</h2>
            {product.images.edges.length > 0 && (
              <img
                src={product.images.edges[0].node.url}
                alt={product.title}
                style={{ width: "200px", borderRadius: "8px" }}
              />
            )}
            <p>{product.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShopifyProductList;
